import React, { ReactChild, useContext, useEffect, useState } from "react";
import { PageStaticDataContext } from "./PageStaticDataContextProvider";
import { BffDataContext } from "./BffDataContextProvider";
import { CloudinaryImage, ContentfulCloudinaryImageComponent } from "../types/ContentfulTypes";
import { getReferentialImageIndex } from "../utils/ReferentialImageryHelper";

export interface ReferentialImageState {
  selectedReferentialImage: ContentfulCloudinaryImageComponent<CloudinaryImage> | undefined;
  referentialImageIndex: number | undefined;
}

export const defaultReferentialImageState: ReferentialImageState = {
  selectedReferentialImage: undefined,
  referentialImageIndex: undefined,
};

export const ReferentialImageContext = React.createContext(defaultReferentialImageState);

interface ReferentialImageContextProviderProps {
  children: ReactChild | ReactChild[] | undefined | null;
}

export const ReferentialImageContextProvider = (props: ReferentialImageContextProviderProps) => {
  const [referentialImageIndex, setReferentialImageIndex] = useState<number | undefined>(undefined);
  const { prices } = useContext(BffDataContext);
  const { referentialImages } = useContext(PageStaticDataContext);

  useEffect(() => {
    const configuration =
      prices[parseInt(Object.keys(prices)[0])]?.possibleConfigurations &&
      prices[parseInt(Object.keys(prices)[0])]?.possibleConfigurations[0];
    const refImageIndex = getReferentialImageIndex({
      referentialImages,
      configuration,
    });
    setReferentialImageIndex(refImageIndex);
  }, [referentialImages, prices]);

  const selectedReferentialImage =
    referentialImageIndex !== undefined
      ? referentialImages?.[referentialImageIndex]?.image
      : undefined;

  return (
    <ReferentialImageContext.Provider
      value={{
        selectedReferentialImage,
        referentialImageIndex,
      }}
    >
      {props.children}
    </ReferentialImageContext.Provider>
  );
};
